export const LEGACY_GLOBAL_ID = '@@global';
